import { render, staticRenderFns } from "./highlight-button-icons.vue?vue&type=template&id=11d12178"
import script from "./highlight-button-icons.vue?vue&type=script&lang=js"
export * from "./highlight-button-icons.vue?vue&type=script&lang=js"
import style0 from "./highlight-button-icons.vue?vue&type=style&index=0&id=11d12178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports